import { PartnerProfileConfig } from '../types';

export const partnerProfileDefaultConfig: PartnerProfileConfig = {
  availableToPro: false,
};
